import React from 'react';

/* eslint-disable */
const Modal = ({
  isOpen = false,
  showIconClose = true,
  textClose = "Cerrar",
  srcIcon,
  title,
  description,
  typeButton,
  textButton,
  linkButton,
  callbackButton,
  callbackClose,
  extraClass,
  children
}) => {
  const getButton = (typeButton, textButton, linkButton, callbackButton) => {
    let buttonComp = <></>;
    if (typeButton === "link") {
      buttonComp = <a href={linkButton} target="_blank" className='rbr-btn'>{textButton}</a>
    }
    if (typeButton === "button") {
      buttonComp = <button type='button' className='rbr-btn' onClick={callbackButton}>{textButton}</button>
    }
    if (typeButton === "loading") {
      buttonComp = <button type='button' className='rbr-btn loading' ><span className="btn__loader" /></button>
    }
    return buttonComp;
  };
  return (
    !isOpen ? <></>
      : <div className={`rbr-modal ${extraClass || ""}`}>
        <div className="rbr-section">
          <div className="rbr-container">
            <div className="rbr-modal__container">
              {showIconClose && 
                <div className="rbr-modal__close" onClick={callbackClose}>
                  <span>{textClose}</span>
                  <i className='icon'></i>
                </div>
              }
              {
                children ? children
                  : <>
                    {
                      srcIcon &&
                      <img src={srcIcon} alt="icon modal" />
                    }
                    <h3>{title}</h3>
                    <p>{description}</p>
                    {
                      typeButton && getButton(typeButton, textButton, linkButton, callbackButton)
                    }
                  </>
              }

            </div>
          </div>
        </div>
      </div>
  )
}

export default Modal